export const supportedFiles = ['gif', 'jpg', 'pdf', 'pptx', 'tif', 'tiff', 'xls', 'xlsx', 'doc', 'docx'];
// Maximum accepted file size in bytes (6 MB). Shared across all document upload features.
export const MAX_FILE_SIZE_BYTES = 6291456;
// Allowed characters in an uploaded document's filename.
export const VALID_FILENAME_REGEX = /^[a-zA-Z0-9_.\s-]*$/;
export const SERVER_UPLOAD_ERROR_TYPES = [
    'INVALID_FILENAME',
    'EMPTY_FILE',
    'UNSUPPORTED_EXTENSION',
    'CORRUPT_FILE',
    'PASSWORD_PROTECTED',
    'FILE_TOO_LARGE',
];
